<div class="service-header-wrapper">
	<h2 class="mat-heading">{{ 'mes.administration.calendar.calendar' | translate }}</h2>

	<div class="service-header-buttons">
		<header-sub-menu [favoriteItems]="favoriteItems"></header-sub-menu>
	</div>
</div>

<div class="select-wrapper">
	<mat-form-field appearance="outline" class="calendar-select prevent-select">
		<mat-select #calendarSelect [(value)]="selectedCalendar" (selectionChange)="onSelected(calendarSelect.value, yearSelect.value, monthSelect.value)">
			@for (calendar of calendars; track calendar) {
				<mat-option [value]="calendar">{{ calendar.alias }}</mat-option>
			}
		</mat-select>
	</mat-form-field>
	<mat-form-field appearance="outline" class="calendar-select prevent-select">
		<mat-select #yearSelect [(value)]="selectedYear" (selectionChange)="onSelected(calendarSelect.value, yearSelect.value, monthSelect.value)">
			@for (year of years; track year) {
				<mat-option [value]="year">{{ year }}</mat-option>
			}
		</mat-select>
	</mat-form-field>
	<mat-form-field appearance="outline" class="calendar-select prevent-select">
		<mat-select #monthSelect [(value)]="selectedMonth" (selectionChange)="onSelected(calendarSelect.value, yearSelect.value, monthSelect.value)">
			@for (month of months; track month) {
				<mat-option [value]="month.no">
					{{ 'mes.administration.calendar.month.' + month.name | translate }}
				</mat-option>
			}
		</mat-select>
	</mat-form-field>
</div>
<div class="calendar-wrapper">
	<app-generic-calendar-component
		[month]="selectedMonth"
		[year]="selectedYear"
		[appointments]="appointments"
		[addAppointmentIcon]="true"
		(appointmentClickedEvent)="appointmentClicked($event)"
		(appointmentDeleteClickedEvent)="appointmentDeleteClicked($event)"
		(calendarDayClickedEvent)="dayClicked($event)"></app-generic-calendar-component>
</div>
